import { RefinementBar } from "./RefinementBar";
import { FacetValueTagsComponent } from "../facetvaluetags/FacetValueTagsComponent";
import { NextBestActionComponent } from "../nextBestAction/NextBestActionComponent";

export function registerRefinementBar() {
  RefinementBar.register();
  FacetValueTagsComponent.register();
  NextBestActionComponent.register();
}
